var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.7277 1.49991L11.3135 0.0856934L6.36372 5.03544L1.41397 0.0856934L-0.000244141 1.49991L6.36372 7.86387L12.7277 1.49991Z"}));
}

ArrowDown.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
